<template>
    <div id="subpage">
        <el-col :span="24" class="warp-breadcrum">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>
                    <b>首页</b>
                </el-breadcrumb-item>
                <el-breadcrumb-item>个人中心</el-breadcrumb-item>
            </el-breadcrumb>
        </el-col>
        <div class="contents" v-loading="loading">
            <div class="h128 bg-w card-shadow pt20 pl25">
                <div class="flex alcenter">
                    <div class="w80 overflow-hidden mr20">
                        <img class="img_round" :src="userStore.headImgUrl" alt="">
                    </div>
                    <div class="">
                        <div class="ft20 text-233650">{{ userStore.nickname ? userStore.nickname : '益题库用户' }}
                        </div>
                        <div class="mt10">
                            <div class="user-vip flex items-center" v-if="userStore.vip_status">
                                会员有效期至：{{ userStore.vip_etime }} ({{ userStore.vip_title }})</div>
                            <div class="user-vip flex items-center" v-else>暂未开通会员</div>
                            <!-- <img class="w440" src="../../../public/images/icon/18.png" alt="" v-else> -->
                        </div>
                    </div>
                    <div class="quit"><el-button type="primary" @click="logout">退出登录</el-button></div>
                </div>
            </div>
            <div class="h513 bg-w mt20 card-shadow">
                <div class="h52 border-b flex">
                    <div class="ft16 text-233650 pl20 pr20">
                        基本信息
                    </div>
                </div>
                <div class="">
                    <div class="list-item">
                        <div class="">用户昵称</div>
                        <div class="">{{ userStore.nickname ? userStore.nickname : '益题库用户' }}</div>
                    </div>
                    <!-- <div class="list-item">
                        <div class="">用户ID</div>
                        <div class="">{{ userStore.serialNumber ? userStore.serialNumber : '无' }}</div>
                    </div> -->
                    <div class="list-item">
                        <div class="">手机号</div>
                        <div class="">{{ userStore.mobile ? userStore.mobile : '未绑定' }}</div>
                    </div>
                    <div class="list-item">
                        <div class="">微信绑定</div>
                        <div class="">{{ userStore.of_openid ? '已绑定' : '未绑定' }}</div>
                    </div>
                    <!-- <div class="list-item">
                        <div class="">开始学习</div>
                        <div class="">{{ userStore.startLearnTime ? userStore.startLearnTime : '未开始学习' }}</div>
                    </div> -->
                    <div class="list-item">
                        <!-- <div>
                            <button class="w-[160px] h-[42px] rounded-[4px] bg-[#3078FF] text-white text-[14px]"
                                @click="openEditUserInfoModal">编 辑</button>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: true,
            userStore: [],
        };
    },
    //进入页面加载
    mounted: function () {
        var that = this;
        that.getUserInfo();
    },
    methods: {
        logout() {
            this.$confirm("此操作将登出后台, 是否继续?", "温馨提示", {
                confirmButtonText: "登出",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    sessionStorage.removeItem("access-token");
                    this.$message({
                        type: "success",
                        message: "退出成功!",
                    });
                    this.$router.push("/web/index");
                });
        },
        /**
         * 获取列表
         */
        getUserInfo() {
            let that = this;
            let column_id = sessionStorage.getItem('access-column_id');
            console.log(column_id);
            that.axios.post("/userInfo", {
                column_id: column_id
            }).then((res) => {
                if (res) {
                    that.userStore = res.data;
                    that.loading = false;
                }
            });
        },
    },

};
</script>
<style>
.flex.alcenter {
    align-items: center;
    position: relative;
}

.quit {
    position: absolute;
    right: 25px;
    top: 0px;
}

.flex-grow {
    flex-grow: 1;
}

.flex-shrink-0 {
    flex-shrink: 0;
}

.inline-block {
    display: inline-block;
}

.text-233650 {
    color: #233650;
}

.border-b {
    border-bottom: 1px solid #F4F4F5;
}

.w440 {
    width: 440px;
}

.w14 {
    width: 14px;
}

.w161 {
    width: 125px;
}

.h128 {
    height: 128px;
}

.h52 {
    height: 52px;
    align-items: center;
}

.h513 {
    height: 513px;
}

.user-vip {
    color: brown;
    font-size: 14px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 15px;
    background-color: rgb(247 230 209);
    align-items: center;
    width: fit-content;
    height: 34px;
}

.contents {
    width: 100%;
    box-sizing: border-box;
    position: relative;
    display: block;
    overflow: hidden;
    height: 100%;
    border-radius: 4px;
}

.list-item {
    display: flex;
    margin-top: 43px;
}

.list-item:nth-of-type(1) {
    margin-top: 37px;
}

.list-item:nth-last-of-type(1) {
    margin-top: 50px;
}

.list-item>div {
    display: flex;
    font-size: 14px;
    color: #233650;
}

.list-item>div:nth-of-type(1) {
    width: 96px;
    box-sizing: border-box;
    margin-left: 32px;
    color: #6F8199;
}

.list-item:nth-last-of-type(1)>div:nth-of-type(1) {
    width: 160px !important;
}
</style>